/**
 * Footer component for the interview booking application
 * Contains legal links (DSGVO compliant), contact info, and copyright
 */
export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-800 text-gray-300">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Contact Information */}
          <div>
            <h3 className="text-white font-semibold mb-3">Kontakt</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="mailto:job@juniva.de"
                  className="hover:text-white transition-colors"
                >
                  job@juniva.de
                </a>
              </li>
              <li>
                <a
                  href="tel:+4924526818335"
                  className="hover:text-white transition-colors"
                >
                  +49 2452 6818335
                </a>
              </li>
              <li className="text-gray-400">
                Mo - Fr: 09:00 - 17:00 Uhr
              </li>
            </ul>
          </div>

          {/* Address */}
          <div>
            <h3 className="text-white font-semibold mb-3">Adresse</h3>
            <address className="text-sm not-italic text-gray-400">
              Juniva gUG<br />
              Oberstraße 3<br />
              D-47829 Krefeld
            </address>
          </div>

          {/* Legal Links (DSGVO) */}
          <div>
            <h3 className="text-white font-semibold mb-3">Rechtliches</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="https://juniva.de/impressum"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Impressum
                </a>
              </li>
              <li>
                <a
                  href="https://juniva.de/datenschutzerklaerung"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Datenschutzerklärung
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-gray-700 text-center text-sm text-gray-400">
          © {currentYear} Juniva gUG. Alle Rechte vorbehalten.
        </div>
      </div>
    </footer>
  );
}
